/* Il modello «riprendi_conversazione»: l'unico che si manda a finestra chiusa (c41). La funzione `wa-modelli`
   dice se Meta lo ha approvato (UTILITY) e mette il messaggio in coda; qui solo la chiamata e il testo. */
/** Il testo approvato da Meta: serve a far vedere cosa è partito. Lo stesso di `_shared/modelli.ts`. */
export const testoRipresa = (contatto, mittente) =>
  `Ciao ${contatto}, sono ${mittente} di Interni D'Autore. Riprendo da qui la nostra conversazione sul tuo progetto: rispondimi pure quando ti è comodo.`;

/** Nel filo il messaggio automatico è salvato come «[modello] parametro · parametro»: qui torna il testo vero. */
export function testoDelModello(salvato) {
  const m = /^\[riprendi_conversazione\]\s*(.*?) · (.*)$/.exec(salvato || "");
  return m ? testoRipresa(m[1], m[2]) : null;
}

/** Il nome da scrivere: la prima parola del nome del contatto, vuota se il contatto è solo un numero. */
export const nomeDaScrivere = (nome) => (!nome || /^\+?\d/.test(nome) ? "" : String(nome).trim().split(/\s+/)[0]);

/* In produzione la funzione sta su Supabase; sul banco di prova una variabile la punta a quella accesa in locale
   (sta in .env.development.local, che la build non legge). */
const URL_FUNZIONE = () =>
  process.env.REACT_APP_WA_MODELLI_URL || `${process.env.REACT_APP_SUPABASE_URL}/functions/v1/wa-modelli`;

async function chiama(corpo) {
  const { supabase } = await import("@/lib/supabase"); // qui e non in testa: il resto del file si prova senza Supabase
  const { data } = await supabase.auth.getSession();
  const r = await fetch(URL_FUNZIONE(), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      apikey: process.env.REACT_APP_SUPABASE_ANON_KEY,
      Authorization: `Bearer ${data?.session?.access_token}`,
    },
    body: JSON.stringify(corpo),
  });
  const json = await r.json().catch(() => ({}));
  return { ok: r.ok, status: r.status, json };
}

/** `{ collegato, modello: { pronto } }`. Se la funzione non risponde non si dice niente di falso: collegato, modello non pronto. */
export async function statoModelli() {
  try {
    const r = await chiama({ op: "stato" });
    if (r.ok) return r.json;
  } catch {
    /* rete o funzione non raggiungibile: vale come «non so» */
  }
  return { collegato: true, modello: { pronto: false } };
}

/** Mette il modello in coda. Lancia un Error col testo della funzione se non è andata. */
export async function mandaModello(waId, nome) {
  let r;
  try {
    r = await chiama({ op: "manda", wa_id: waId, nome });
  } catch {
    throw new Error("Non sono riuscito a mandarlo: riprova fra un momento.");
  }
  if (!r.ok) throw new Error(r.json?.errore || "Non è partito: riprova fra un momento.");
  return r.json;
}
